<template>
  <div id="top">
    <div class="left" style="margin-left: 30px; height: 60px;">

      <img :src="logo" style="height: 40px; padding-bottom: 10px; padding-top: 10px"/>
      <div style="display: inline-block; position: absolute; font-size: 22px">·联盟媒体服务平台</div>
    </div>
    <div class="left" style="margin-left: 200px">
      <el-menu mode="horizontal"
               background-color="#1E232E"
               text-color="white"
               active-text-color="#409EFF"
               :default-active="defaultActive">
        <template v-for="(menu) in headerMenu">
          <el-menu-item :index="menu.index"
                        :key="menu.name"
                        @click="handleMenuClick(menu)">
            <span class="top-tab-content">{{menu.label}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>

    <div class="right">
        <el-menu ref="profileMenu"
               background-color="#1E232E"
               text-color="white"
               active-text-color="white"
                mode="horizontal"
                @select="handleProfileMenuClick">
          <el-submenu index="10" :active="false">
            <template slot="title">
              <div style="line-height: 60px; float: left">
                <div>
                  <span >{{this.userName}}</span>
                </div>
              </div>
            </template>
            <div style="color: white; padding: 10px">
              <div style="font-size: 14px">{{'账户信息'}}</div>
              <div style="color: #999999; font-size: 13px; margin-top: 5px">{{'账户名称: ' + account.name}}</div>
              <div style="color: #999999; font-size: 13px">{{'账户ID: ' + account.id}}</div>
              <div style="color: #999999; font-size: 13px">{{'账户邮箱: ' + account.email}}</div>
              <div style="color: #999999; font-size: 13px">{{'账户类型: ' + account.type}}</div>
            </div>
            <el-menu-item v-for="(menu) in profileMenu" @click="handleMenuClick(menu)" v-bind:index="menu.name" :key="menu.name"><span class="top-sub-tab-content">{{menu.label}}</span></el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
  </div>
</template>
<script>
  import GlobalEvents from '@/enums/global-events'
  import _ from 'lodash'
  import {sspApi} from '@/api';
  import store from '@/data/store'

  export default {
    name: 'qxTop',
    computed: {
        logo: function () {
            return require('@/assets/image/top-menu-logo.png');
        },
        userName: function () {
          return this.$store.state.accountInfo.name;
        },
        account: function () {
          return this.$store.state.accountInfo;
        },
        defaultActive:function() {
          let tab1 = ['media', 'adzone', 'deviceTargetingConfig']
          let tab2 = ['report']
          let tab3 = ['installedListCallback', 'packageName']
          if (_.find(tab1, (it) => this.$route.name.includes(it))) {
            return '1'
          } else if (_.find(tab3, (it) => this.$route.name.includes(it))) {
            return '3'
          } else {
            return '2'
          }
        },
    },
    data: function() {
      return {
          headerMenu: [
              {index:'1', name: 'media', label: '媒体流量服务', action: {type: 'route', val: 'media'}},
              {index:'2', name: 'report', label: '数据报表', action: {type: 'route', val: 'reportAccount'}},
              {index:'3', name: 'installedListCallback', label: '已安装列表回传管理(API)', action: {type: 'route', val: 'installedListCallback'}},
              ],
          profileMenu: [
              {name: 'changePwd', label: '更改密码'},
              {name: 'logout', label: '登出'},
              ],
          enableIframe: false
      }
    },
    methods: {
      changePwd: function () {
        this.$notify.info({ title: '更改密码', message: '一封密码重置邮件将发送至您的邮箱，请根据邮件指示操作重置密码' });
        sspApi.changePwd().then(() => {
          this.$notify.success({ title: '请求成功', message: '密码重置邮件已发送' });
        }).catch((e) => {
          this.$notify.error({ title: '请求失败', message: '密码重置邮件未成功发送，请重试' });
        })
      },
      handleMenuClick: function(menu) {
        if (menu.name === "changePwd") {
          this.changePwd()
          return
        }
        if (menu.name === "logout") {
          this.logout()
          return
        }
        this.$router.push({ name: menu.action.val}).catch(() => {});
      },
      logout: function () {
        //clear store data
        store.commit('setAccountInfo', {});

        //to logout page
        window.location.href = process.env.VUE_APP_LOGOUT_URL;

      },
      handleProfileMenuClick: function (menu) {
        this.$refs.profileMenu.activeIndex = -1;
      }
    },
  }
</script>

<style scoped>
 #top {
    margin: 0 auto;
    background-color: #1E232E;
    height: 61px;
    color: white;
  }
.left {
    float: left;
    line-height: 61px;
    margin-left: 40px;
  }
  .logo {
    vertical-align: middle;
    cursor: pointer;
    height: 37px;
  }
  .right {
    float: right;
    line-height: 60px;
  }
  .top-title {
    font-size: 20px;
    margin-left: 10px;
  }
  #top >>> .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #409EFF;
    color: #409EFF;
}

</style>


